const BIOMARKERS_URL = process.env.API_URL + '/xugarhero/analytics/biomarkers';
const NOT_FOUND_URL = BIOMARKERS_URL + '/not-found';
const NAME_URL = NOT_FOUND_URL + '/names';
const UNIT_URL = NOT_FOUND_URL + '/units';
const ANALYTICS_URL = process.env.API_URL + '/xugarhero/analytics';

// ==========================================
// MÉTODOS PARA NOMBRES NO ENCONTRADOS
// ==========================================

const getNotFoundNames = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(NAME_URL)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const resolveName = (context, id, acceptedBiomarkerId) => {
  return new Promise((resolve, reject) => {
    context.$http.post(`${BIOMARKERS_URL}/resolve/name`, {
      notFoundId: id,
      acceptedBiomarkerId: acceptedBiomarkerId
    })
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getNotFoundUnits = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(UNIT_URL)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const resolveUnit = (context, id, acceptedUnitCanonical, conversionFactor) => {
  return new Promise((resolve, reject) => {
    context.$http.post(`${BIOMARKERS_URL}/resolve/unit`, {
      notFoundId: id,
      acceptedUnitCanonical: acceptedUnitCanonical,
      conversionFactor: conversionFactor
    })
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const rejectBiomarker = (context, id) => {
  return new Promise((resolve, reject) => {
    context.$http.post(`${BIOMARKERS_URL}/reject`, {
      notFoundId: id
    })
      .then((response) => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};
const getAllCanonicalUnits = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(`${BIOMARKERS_URL}/units`)
      .then(response => resolve(response.body), error => reject(error));
  });
};

const getAnalytics = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(ANALYTICS_URL)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getAllAnalytics = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(ANALYTICS_URL + '/all')
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getImportLog = (context, analyticId) => {
  return new Promise((resolve, reject) => {
    context.$http.get(ANALYTICS_URL + '/import-log/' + analyticId)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getAllBiomarkers = (context) => {
  return new Promise((resolve, reject) => {
    // IMPORTANTE: Comprueba si la ruta de tu backend para pedir todos
    // los biomarcadores es exactamente esta u otra parecida (ej: BIOMARKERS_URL + '/all')
    context.$http.get(BIOMARKERS_URL)
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getAnalytics,
  getAllAnalytics,
  getImportLog,
  getNotFoundNames,
  resolveName,
  getNotFoundUnits,
  resolveUnit,
  rejectBiomarker,
  getAllCanonicalUnits,
  getAllBiomarkers
};



// WEBPACK FOOTER //
// ./src/brand/health/api/analytics/index.js